<template>
  <section>
    <h3 class="h-title">提交文件-业务文件</h3> 
    <el-form class="e-form f-b" ref="cForm3" :model="cForm3" label-width="auto"  label-position="left" :rules="setpFormRules4">  
        <el-form-item class="w-70" label="公示公告信披服务申请书（客户-中数）" prop="serviceApplyZsFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceApplyZsFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceApplyZsFile')" 
            :on-error="handleError"
            :file-list="cForm3.serviceApplyZsFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="推介服务协议" prop="suggestProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'suggestProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'suggestProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm3.suggestProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公示公告信息披露协议" prop="infoDisclosuresProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'infoDisclosuresProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'infoDisclosuresProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm3.infoDisclosuresProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 

      <el-form-item class="w-70 label-more-r" label="法律综合服务协议" prop="lawAllProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'lawAllProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'lawAllProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm3.lawAllProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item class="w-70 label-more" label="公示公告信披服务申请书（客户-律所）" prop="serviceApplyLawFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceApplyLawFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceApplyLawFile')" 
            :on-error="handleError"
            :file-list="cForm3.serviceApplyLawFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item>
    
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">		
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>
<script>
import baseUrl from '@/api/baseUrl.js'
export default {
    name: "step3",
    props: ["active"],
		data() {
			return {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        },      
        cForm3: {}, 
				setpFormRules4: {
          serviceApplyZsFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          suggestProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          infoDisclosuresProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          lawAllProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          serviceApplyLawFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ]
        },
        action: '',
        butLoading: false,
        sceneTypeText: ''
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 3) {
          window.scrollTo(0,0);
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm3 = JSON.parse(sessionStorage.setpForm);
          this.cForm3.serviceApplyZsFile = JSON.parse(this.cForm3.serviceApplyZsFile || '[]');
          this.cForm3.suggestProtocolFile = JSON.parse(this.cForm3.suggestProtocolFile || '[]');
          this.cForm3.infoDisclosuresProtocolFile = JSON.parse(this.cForm3.infoDisclosuresProtocolFile || '[]');
          this.cForm3.lawAllProtocolFile = JSON.parse(this.cForm3.lawAllProtocolFile || '[]');
          this.cForm3.serviceApplyLawFile = JSON.parse(this.cForm3.serviceApplyLawFile || '[]');
        } 
      }
    },
    methods: {  
      fontData(){
        this.cForm3.serviceApplyZsFile = JSON.stringify(this.cForm3.serviceApplyZsFile||[]);
        this.cForm3.suggestProtocolFile = JSON.stringify(this.cForm3.suggestProtocolFile||[]);
        this.cForm3.infoDisclosuresProtocolFile = JSON.stringify(this.cForm3.infoDisclosuresProtocolFile||[]);
        this.cForm3.lawAllProtocolFile = JSON.stringify(this.cForm3.lawAllProtocolFile||[]);
        this.cForm3.serviceApplyLawFile = JSON.stringify(this.cForm3.serviceApplyLawFile||[]);
      },
      cSubmitForm(type) {
        if(type == '0'){
          this.butLoading = true;
          this.cForm3.status = '0'
          this.fontData()
          this.$api.announcement.addAndUpd(JSON.stringify(this.cForm3)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("保存成功");
              this.$router.go(-1);
            }     
          });
        }else{
          // 文件必填校验
          this.$refs["cForm3"].validate((valid) => {
            if ( valid ) {  
              this.fontData()
              sessionStorage.setpForm = JSON.stringify(this.cForm3);
              this.$emit('next');
            }
          })    
        }          
      },
      prev() {
        this.fontData()
        sessionStorage.setpForm = JSON.stringify(this.cForm3);
        this.$emit('prev')
      },
      handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm3, name, [{
                name: response.name,
                url: response.url
              }])
            this.$refs.cForm3.clearValidate(name)
          }else{
            this.$set(this.cForm3, name,[])
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm3, name, [])
      },
    }
	}
</script>